import './styles/styles.css';
import Particles from './components/particles.js';
import PageRouter from "./components/router.js";
import { Router, Link, useLocation } from "wouter";
 
function App() {
  return (
    <Router>
        <div className="App">

            <PageRouter />

            {/* <Particles id="tsparticles" /> */}
        </div>
    </Router>
  );
}

export default App;
